// src/utils/normalizedPower.js

// Lee potencia de forma MUY robusta (muchos parsers cambian nombres/estructuras)
export const readPower = (r) => {
  if (!r || typeof r !== "object") return null;

  // SOLO potencia instantánea (por record)
  const candidates = [
    r.power,
    r.enhanced_power,
    r.enhancedPower,
    r.power_w,
    r.powerWatts,
    r.watts,
    r?.data?.power,
    r?.data?.watts,
    r?.values?.power,
    r?.values?.watts,
    r?.record?.power,
    r?.record?.watts,
  ];

  for (const v of candidates) {
    const n = Number(v);
    // filtro anti-basura (ajústalo si quieres, pero pon SIEMPRE algún límite)
    if (Number.isFinite(n) && n >= 0 && n <= 2500) return n;
  }

  // sin regex fallback: preferimos NULL antes que potencia falsa
  return null;
};


// Normalized Power (NP) estilo TrainingPeaks: rolling 30s, 4th power, mean, 4th root
export const calculateNormalizedPower = (records, opts = {}) => {
  const {
    windowSizeSec = 30,
    includeZeros = true, // CLAVE: TP considera ceros/coasting (o ausencia) dentro del tiempo
    debug = false,
  } = opts;

  if (!Array.isArray(records) || records.length === 0) {
    if (debug) console.warn("[NP] records inválidos/vacíos");
    return null;
  }

  const series = [];
  let valid = 0;

  for (const r of records) {
    const p = readPower(r);
    if (Number.isFinite(p)) {
      series.push(p);
      if (p > 0) valid += 1;
    } else {
      if (includeZeros) series.push(0);
    }
  }

  if (debug) {
    console.log("[NP] records:", records.length, "serie:", series.length, "valid>0:", valid);
  }

  // necesita al menos windowSizeSec muestras (asumimos ~1Hz)
  if (series.length < windowSizeSec) {
    if (debug) console.warn("[NP] serie insuficiente para NP:", series.length);
    return null;
  }

  const movingAvg = [];
  for (let i = 0; i <= series.length - windowSizeSec; i++) {
    let sum = 0;
    for (let j = 0; j < windowSizeSec; j++) sum += series[i + j];
    movingAvg.push(sum / windowSizeSec);
  }

  const raised = movingAvg.map((v) => Math.pow(v, 4));
  const mean = raised.reduce((sum, v) => sum + v, 0) / raised.length;
  const np = Math.pow(mean, 1 / 4);

  return Number.isFinite(np) ? Math.round(np) : null;
};
